import { DToolTip } from "@dfa/ui-platform";
import { sanitizeHtml } from "utils/sanitizeHtml";
import type { DToolTipDataAdapterData } from "./types";
import { PropsWithChildren } from "react";

/**
 * Simple DIV wrapper to give us the flex-start/flex-end placement
 * @param {string} align - The alignment required. Defaults to 'left'
 * @returns React.ReactElement
 */
const DToolTipAdapterContainer = ({
	align = "left",
	content,
	label = "-",
	size = "default"
}: PropsWithChildren<DToolTipDataAdapterData>) => {
	const className = `d-tooltip-adapter-container ${align === "right" ? "right" : ""}`;

	return (
		<div className={className}>
			<DToolTip
				config={{
					boundaryRef: document.querySelector(".main"),
					boundaryPadding: {
						top: 150,
						left: 50,
						right: 50
					},
					cssProperties: { zIndex: 1 },
					placementMiddleware: "flip"
				}}
				icon="little-i"
				label={label}
				placement={align === "right" ? "top-end" : "top-start"}
				size={size}
				removePortal={true}
			>
				<div dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }} />
			</DToolTip>
		</div>
	);
};

export default DToolTipAdapterContainer;
